// extracted by mini-css-extract-plugin
export default {"stack":"RevisionsStatus_stack__Qv2tA","sliver":"RevisionsStatus_sliver__M9SSJ"};